import { default as communicationUtil } from './communication';

export {
  communicationUtil
};



// WEBPACK FOOTER //
// ./src/utilities/index.js